"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasErrorMessagesInErrorObject = exports.getTransportDirection = exports.hasPassenger = exports.isUserG2G = exports.getFlightReqSets = exports.isMinorOnDate = exports.objectDelta = exports.isAllNullish = exports.fixEmptyString = exports.setResourceValue = exports.setLanguageCookie = exports.getQueryString = exports.getResourceValue = exports.getLanguageCookie = exports.getBrowserLanguage = exports.reduceResourceArrayToObjById = exports.toArray = undefined;

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _deepcopy = require("deepcopy");

var _deepcopy2 = _interopRequireDefault(_deepcopy);

var _universalCookie = require("universal-cookie");

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookies = new _universalCookie2.default();

var toArray = exports.toArray = function toArray() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var array = [];
    (0, _keys2.default)(obj).forEach(function (key) {
        array.push(obj[key]);
    });
    return array;
};

var reduceResourceArrayToObjById = exports.reduceResourceArrayToObjById = function reduceResourceArrayToObjById(resourceArray, idField) {
    return resourceArray.reduce(function (resourcesById, resource) {
        resourcesById[resource[idField]] = resource;
        return resourcesById;
    }, {});
};

var getBrowserLanguage = exports.getBrowserLanguage = function getBrowserLanguage() {
    var browserLang = navigator.langauges && navigator.languages[0] || navigator.language || navigator.userLanguage;

    // Split locales with a region code
    return browserLang.toLowerCase().split(/[_-]+/)[0];
};

var getLanguageCookie = exports.getLanguageCookie = function getLanguageCookie(cookieName) {
    return cookies.get(cookieName);
};

// Given a pathString (ex: 'name.legal_first_name', name['legal_first_name'])
//  and a resource object, will return the value (undefined if not found)
function getResourceValueWithPath(resource, prop) {
    if (!resource) return resource;

    for (var _len = arguments.length, restOfPath = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        restOfPath[_key - 2] = arguments[_key];
    }

    return restOfPath.length > 0 ? getResourceValueWithPath.apply(undefined, [resource[prop]].concat(restOfPath)) : resource[prop];
}

var getResourceValue = exports.getResourceValue = function getResourceValue(pathString, resource) {
    var path = _lodash2.default.toPath(pathString);
    return path.length > 0 ? getResourceValueWithPath.apply(undefined, [resource].concat((0, _toConsumableArray3.default)(path))) : undefined;
};

var getQueryString = exports.getQueryString = function getQueryString() {
    return window.location.search;
};

var setLanguageCookie = exports.setLanguageCookie = function setLanguageCookie(cookieName, locale) {
    return cookies.set(cookieName, locale);
};

// Given a pathString (ex: 'name.legal_first_name', name['legal_first_name']),
//  a resource object, and a value to set, will return a new resource with the setValue
//  in the location of the pathString (even if the fields in pathString do not yet exist)
function setResourceValueWithPath(resource, value, prop) {
    if (prop === undefined) return value;

    for (var _len2 = arguments.length, restOfPath = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        restOfPath[_key2 - 3] = arguments[_key2];
    }

    var setSubResource = setResourceValueWithPath.apply(undefined, [resource && resource[prop], value].concat(restOfPath));

    if (!resource) {
        var initialized = isNaN(prop) ? {} : [];
        initialized[prop] = setSubResource;
        return initialized;
    } else {
        var existingIsArray = !isNaN(prop);
        if (existingIsArray) {
            var newArr = [].concat((0, _toConsumableArray3.default)(resource));
            newArr[prop] = setSubResource;
            return newArr;
        } else {
            return (0, _extends4.default)({}, resource, (0, _defineProperty3.default)({}, prop, setSubResource));
        }
    }
}

var setResourceValue = exports.setResourceValue = function setResourceValue(pathString, resource, value) {
    return setResourceValueWithPath.apply(undefined, [resource, value].concat((0, _toConsumableArray3.default)(_lodash2.default.toPath(pathString))));
};

var fixEmptyString = exports.fixEmptyString = function fixEmptyString(value) {
    if (_lodash2.default.isObject(value) && !_lodash2.default.isArray(value)) {
        (0, _keys2.default)(value).forEach(function (prop) {
            value[prop] = fixEmptyString(value[prop]);
        });
        return value;
    } else if (_lodash2.default.isArray(value)) {
        return value.map(fixEmptyString);
    } else if (value === "") {
        return null;
    } else {
        return value;
    }
};

// Returns true when the value is null/undefined or any nested structure only
// contains nullish values.
var isAllNullish = exports.isAllNullish = function isAllNullish(value) {
    if (value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.every(isAllNullish);
    if (_lodash2.default.isObject(value)) {
        var values = (0, _values2.default)(value);
        return values.length === 0 || values.every(isAllNullish);
    }
    return false;
};

// Returns the delta object of objectOne and objectTwo, along with a list of what fields changed (in string form)
// (Thanks to Vjeux: http://blog.vjeux.com/2011/javascript/object-difference.html)
var objectDelta = exports.objectDelta = function objectDelta(objectOne, objectTwo) {
    var delta = {};
    (0, _keys2.default)(objectTwo).forEach(function (prop) {
        if (objectOne.hasOwnProperty(prop)) {
            // Property is in objectOne, see if value changed
            if (_lodash2.default.isObject(objectTwo[prop]) && !_lodash2.default.isArray(objectTwo[prop])) {
                // Value is an object, dig deeper to compare sub-props/values
                var subDelta = objectDelta(objectOne[prop], objectTwo[prop]);
                if (!_lodash2.default.isEmpty(subDelta)) {
                    delta[prop] = subDelta;
                }
            } else if (!_lodash2.default.isEqual(objectOne[prop], objectTwo[prop])) {
                // Value is not an object, and has changed, add to delta
                // (deepcopy in case objectTwo[prop] is array)
                delta[prop] = (0, _deepcopy2.default)(objectTwo[prop]);
            }
        } else {
            // Property was not in objectOne, it's new - so add to delta
            // (deepcopy in case objectTwo[prop] is array or object)
            delta[prop] = (0, _deepcopy2.default)(objectTwo[prop]);
        }
    });
    return delta;
};

var isMinorOnDate = exports.isMinorOnDate = function isMinorOnDate(bdayString, dateString) {
    // Expect bdayString and dateString in yyyy-mm-dd form
    var bdayDate = new Date(bdayString);
    var dateDate = dateString ? new Date(dateString) : new Date(); // assumes today if dateString is falsy
    var yearsDiff = dateDate.getFullYear() - bdayDate.getFullYear();

    var hasBdayOccured = dateDate >= new Date(bdayDate).setFullYear(dateDate.getFullYear());

    return (hasBdayOccured ? yearsDiff : yearsDiff - 1) < 18;
};

var getFlightReqSets = exports.getFlightReqSets = function getFlightReqSets(reqSetsByPax) {
    var flightReqs = {};
    (0, _keys2.default)(reqSetsByPax).map(function (id) {
        flightReqs[id] = flightReqs[id] || {};
        if (reqSetsByPax[id].reqSetsByCode && reqSetsByPax[id].reqSetsByCode.FLIGHT_INFORMATION) {
            flightReqs[id].FLIGHT_INFORMATION = reqSetsByPax[id].reqSetsByCode.FLIGHT_INFORMATION;
        }
    });
    return flightReqs;
};

var isUserG2G = exports.isUserG2G = function isUserG2G(reqSetsForPax) {
    return reqSetsForPax && reqSetsForPax.totalReqSets === reqSetsForPax.reqSetsComplete;
};

/**
 * Determines whether a passenger/customer exists in a list.
 *
 * @param {Array<Object>} passengers List of passenger/customer objects.
 * @param {string} passengerId The passenger/customer ID to check for.
 * @returns {boolean} True if the passenger exists, otherwise false.
 */
var hasPassenger = exports.hasPassenger = function hasPassenger(passengers, passengerId) {
    return passengers.some(function (customer) {
        return customer.id === passengerId;
    });
};

/**
 * Determines whether a transport sub_type is an arrival or departure transfer.
 *
 * @param {Object} transportData
 * @returns {{ isArrival: boolean, isDeparture: boolean }}
 */
var getTransportDirection = exports.getTransportDirection = function getTransportDirection(transportData) {
    var subType = (transportData && transportData.sub_type ? transportData.sub_type : "").trim().toLowerCase();

    return {
        isArrival: subType.includes("arrival"),
        isDeparture: subType.includes("departure")
    };
};

/**
 * Return true if there are error messages.
 *
 * @param {Object} errorObject
 * @returns {boolean}
 */
var hasErrorMessagesInErrorObject = exports.hasErrorMessagesInErrorObject = function hasErrorMessagesInErrorObject(errorObject) {
    var hasErrors = _lodash2.default.get(errorObject, 'errors', []);
    return !!hasErrors.length;
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/utilityFunctions.js
// module id = 37
// module chunks = 0